const DEPARTUREDEFAULT: string = 'DEPARTUREDEFAULT';
const ARRIVALDEFAULT: string = 'ARRIVALDEFAULT';
const DEPARTUREFLIGHT: string = 'DEPARTUREFLIGHT';
const DEPARTUREFLIGHTANDTIME: string = 'DEPARTUREFLIGHTANDTIME';
const ARRIVALFLIGHT: string = 'ARRIVALFLIGHT';
const DEPARTURETIMETABLE: string = 'DEPARTURETIMETABLE';
const ARRIVALTIMETABLE: string = 'ARRIVALTIMETABLE';
const ARRIVALFLIGHTANDTIMETABLE: string = 'ARRIVALFLIGHTANDTIMETABLE';

export interface BookingConfig {
  organizationId: string,
  parkingId: string,
  timeZone: string,
  bookingConfigTypes: BookingConfigType[]
}

export interface BookingConfigType {
  configType: string,
  sendOrderConf: boolean,
  bookingNrDepartureRequired: boolean,
  bookingNrArrivalRequired: boolean,
  carIdRequired: boolean,
  headerConfig: HeaderConfig,
  orderConfig: OrderConfig,
  shuttlesConfig: ShuttleConfig[]
}

export interface HeaderConfig {
  logoUrl: string;
  logoAlt: string;
  header1SV: string;
  header1EN: string;
  header2SV: string;
  header2EN: string;
}

export interface OrderConfig {
  bundleCode: string;
}

export interface ShuttleConfig {
  type: string;
  stationCode: string;
  shuttleTypeCode: string;
  shuttleTypeCheckboxSV: string;
  shuttleTypeCheckboxEN: string;
  shuttleTypeDescriptionSV: string;
  shuttleTypeDescriptionEN: string;
  productCode: string;
  routeCode: string;
  shuttleDateOffsetMinutes: number;
  shuttleDateOffsetMinutesNoBag: number;
  terminals: TerminalConfig[]
}

export interface TerminalConfig {
  terminalName: string;
  terminalCode: string;
}

export const BOOKING_CONFIG_MABI: BookingConfig = {
  organizationId: 'A09630B0-C850-483F-9EAC-F5DB80D28893',
  parkingId: '8C98315A-B2AD-4E70-86F9-5D54992FED26',
  timeZone: 'Europe/Stockholm',
  bookingConfigTypes: [
    {
      configType: 'EXTERNAL',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: false,
      carIdRequired: true,
      headerConfig:
      {
        logoUrl: '../../../assets/img/mabi_logo_primary.png',
        logoAlt: 'mabi-logo',
        header1SV: 'Boka återlämning och transfer till Arlanda',
        header1EN: 'Book return and transfer to Arlanda',
        header2SV: '',
        header2EN: '',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: DEPARTUREFLIGHTANDTIME,
            stationCode: 'ARN',
            shuttleTypeCode: 'mabi-external',
            shuttleTypeCheckboxSV: 'Till Arlanda',
            shuttleTypeCheckboxEN: 'To Arlanda',
            shuttleTypeDescriptionSV: 'Boka återlämning och transfer till Arlanda',
            shuttleTypeDescriptionEN: 'Book return and transfer to Arlanda',
            productCode: 'SHUTDEP',
            routeCode: 'CQARLDEP',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          }
        ]
    },
    {
      configType: 'INTERNAL',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: false,
      carIdRequired: true,
      headerConfig:
      {
        logoUrl: '../../../assets/img/mabi_logo_primary.png',
        logoAlt: 'mabi-logo',
        header1SV: 'Boka hämtning och återlämning med transfer till och från Arlanda',
        header1EN: 'Book pickup and return with transfer to and from Arlanda',
        header2SV: '',
        header2EN: '',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: DEPARTUREFLIGHTANDTIME,
            stationCode: 'ARN',
            shuttleTypeCode: 'mabi-airport-transfer',
            shuttleTypeCheckboxSV: 'Till Arlanda',
            shuttleTypeCheckboxEN: 'To Arlanda',
            shuttleTypeDescriptionSV: 'Boka återlämning och transfer till Arlanda',
            shuttleTypeDescriptionEN: 'Book return and transfer to Arlanda',
            productCode: 'SHUTDEP',
            routeCode: 'CQARLDEP',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
          {
            type: ARRIVALFLIGHT,
            stationCode: 'ARN',
            shuttleTypeCode: 'mabi-parking-transfer',
            shuttleTypeCheckboxSV: 'Till Mabi',
            shuttleTypeCheckboxEN: 'To Mabi',
            shuttleTypeDescriptionSV: 'Boka hämtning och transfer från Arlanda',
            shuttleTypeDescriptionEN: 'Book pickup and transfer from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'CQARLDEP',
            shuttleDateOffsetMinutes: 45,
            shuttleDateOffsetMinutesNoBag: 25,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          }
        ]
    }
  ]
};

export const BOOKING_CONFIG_SCANDIC: BookingConfig = {
  organizationId: '417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1',
  parkingId: '8C98315A-B2AD-4E70-86F9-5D54992FED26',
  timeZone: 'Europe/Stockholm',
  bookingConfigTypes: [
    {
      configType: 'HOTEL',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/Scandic_logo.svg',
        logoAlt: 'scandic-hotel-logo',
        header1SV: 'Boka transfer till och från Scandic Arlandastad',
        header1EN: 'Book transfer to and from Scandic Arlandastad',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: DEPARTURETIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'scandic-airport-transfer-new',
            shuttleTypeCheckboxSV: 'Till Arlanda',
            shuttleTypeCheckboxEN: 'To Arlanda',
            shuttleTypeDescriptionSV: 'Transfer till Arlanda från Scandic Arlandastad',
            shuttleTypeDescriptionEN: 'Transfer to Arlanda from Scandic Arlandastad',
            productCode: 'SHUTDEP',
            routeCode: 'QUALITYARLDEP',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
          {
            type: ARRIVALFLIGHTANDTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'scandic-hotel-transfer-new',
            shuttleTypeCheckboxSV: 'Till Scandic Arlandastad',
            shuttleTypeCheckboxEN: 'To Scandic Arlandastad',
            shuttleTypeDescriptionSV: 'Transfer till Scandic Arlandastad från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Scandic Arlandastad from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 45,
            shuttleDateOffsetMinutesNoBag: 25,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    },
    {
      configType: 'DIRECT',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/Scandic_logo.svg',
        logoAlt: 'scandic-hotel-logo',
        header1SV: 'Boka transfer till Scandic Arlandastad',
        header1EN: 'Book your transfer to Scandic Arlandastad',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: ARRIVALTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'scandic-hotel-transfer-new',
            shuttleTypeCheckboxSV: 'Till Scandic Arlandastad',
            shuttleTypeCheckboxEN: 'To Scandic Arlandastad',
            shuttleTypeDescriptionSV: 'Transfer till Scandic Arlandastad från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Scandic Arlandastad from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    }
  ]
};

export const BOOKING_CONFIG_APART: BookingConfig = {
  organizationId: '5BF79F25-27BF-4B5B-AF83-B4A0233DAB70',
  parkingId: '8C98315A-B2AD-4E70-86F9-5D54992FED26',
  timeZone: 'Europe/Stockholm',
  bookingConfigTypes: [
    {
      configType: 'HOTEL',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/apartdirect.jpg',
        logoAlt: 'ApartDirect-logo',
        header1SV: 'Boka transfer till och från ApartDirect',
        header1EN: 'Book transfer to and from ApartDirect',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: DEPARTURETIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'apart-airport-transfer-new',
            shuttleTypeCheckboxSV: 'Till Arlanda',
            shuttleTypeCheckboxEN: 'To Arlanda',
            shuttleTypeDescriptionSV: 'Transfer till Arlanda från ApartDirect',
            shuttleTypeDescriptionEN: 'Transfer to Arlanda from ApartDirect',
            productCode: 'SHUTDEP',
            routeCode: 'QUALITYARLDEP',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
          {
            type: ARRIVALFLIGHTANDTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'apart-hotel-transfer-new',
            shuttleTypeCheckboxSV: 'Till ApartDirect',
            shuttleTypeCheckboxEN: 'To ApartDirect',
            shuttleTypeDescriptionSV: 'Transfer till ApartDirect från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to ApartDirect from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 45,
            shuttleDateOffsetMinutesNoBag: 25,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    },
    {
      configType: 'DIRECT',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/ApartDirect.jpg',
        logoAlt: 'ApartDirect-logo',
        header1SV: 'Boka transfer till ApartDirect',
        header1EN: 'Book your transfer to ApartDirect',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: ARRIVALTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'apart-hotel-transfer-new',
            shuttleTypeCheckboxSV: 'Till ApartDirect',
            shuttleTypeCheckboxEN: 'To ApartDirect',
            shuttleTypeDescriptionSV: 'Transfer till ApartDirect från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to ApartDirect from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    }
  ]
};

export const BOOKING_CONFIG_ARLANDAXPOAPARTMENTS: BookingConfig = {
  organizationId: 'ac589e4e-5e38-4555-9bbf-ad4b1e2ad0da',
  parkingId: '8C98315A-B2AD-4E70-86F9-5D54992FED26',
  timeZone: 'Europe/Stockholm',
  bookingConfigTypes: [
    {
      configType: 'HOTEL',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/arlandaxpoapartments.png',
        logoAlt: 'arlandaxpoapartments-hotel-logo',
        header1SV: 'Boka transfer till Arlanda',
        header1EN: 'Book transfer to Arlanda',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: DEPARTURETIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'arlandaxpoapartments-airport-transfer',
            shuttleTypeCheckboxSV: 'Till Arlanda',
            shuttleTypeCheckboxEN: 'To Arlanda',
            shuttleTypeDescriptionSV: 'Transfer till Arlanda från Arlanda XPO Apartments',
            shuttleTypeDescriptionEN: 'Transfer to Arlanda from  Arlanda XPO Apartments',
            productCode: 'SHUTDEP',
            routeCode: 'ARLANDAXPOAPPARTMENTSARLDEP',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
          {
            type: ARRIVALFLIGHTANDTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'arlandaxpoapartments-hotel-transfer',
            shuttleTypeCheckboxSV: 'Till Arlanda XPO Apartments',
            shuttleTypeCheckboxEN: 'To Arlanda XPO Apartments',
            shuttleTypeDescriptionSV: 'Transfer till Arlanda XPO Apartments från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Arlanda XPO Apartments from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'ARLANDAXPOAPPARTMENTSARLARR',
            shuttleDateOffsetMinutes: 45,
            shuttleDateOffsetMinutesNoBag: 25,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    },
    {
      configType: 'DIRECT',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/arlandaxpoapartments.png',
        logoAlt: 'arlandaxpoapartments-hotel-logo',
        header1SV: 'Boka transfer till Arlanda XPO Apartments',
        header1EN: 'Book your transfer to Arlanda XPO Apartments',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: ARRIVALTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'arlandaxpoapartments-hotel-direct-transfer',
            shuttleTypeCheckboxSV: 'Till Arlanda XPO Apartments',
            shuttleTypeCheckboxEN: 'To Arlanda XPO Apartments',
            shuttleTypeDescriptionSV: 'Transfer till Arlanda XPO Apartments från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Arlanda XPO Apartments from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'ARLANDAXPOAPPARTMENTSARLARR',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    }
  ]
};

export const BOOKING_CONFIG_QUALITY: BookingConfig = {
  organizationId: '39218780-069A-4C6B-9925-22365A075C15',
  parkingId: '8C98315A-B2AD-4E70-86F9-5D54992FED26',
  timeZone: 'Europe/Stockholm',
  bookingConfigTypes: [
    {
      configType: 'HOTEL',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/quality-hotel-airport-arlanda.svg',
        logoAlt: 'quality-hotel-logo',
        header1SV: 'Transferbokning för Quality Hotel Arlanda XPO',
        header1EN: 'Transfer booking for Quality Hotel Arlanda XPO',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'QUALITYSHUARRDEP'
      },
      shuttlesConfig:
        [
          {
            type: DEPARTURETIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'quality-hotel-xpo-arlanda-airport-transfer',
            shuttleTypeCheckboxSV: 'Till Arlanda',
            shuttleTypeCheckboxEN: 'To Arlanda',
            shuttleTypeDescriptionSV: 'Transfer till Arlanda från Quality Hotel',
            shuttleTypeDescriptionEN: 'Transfer to Arlanda from Quality Hotel',
            productCode: 'QUALITYARLDEP',
            routeCode: 'QUALITYARLDEP',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
          {
            type: ARRIVALFLIGHTANDTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'quality-hotel-xpo-arlanda-hotel-transfer',
            shuttleTypeCheckboxSV: 'Till Quality Hotel',
            shuttleTypeCheckboxEN: 'To Quality Hotel',
            shuttleTypeDescriptionSV: 'Transfer till Quality Hotel från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Quality Hotel from Arlanda',
            productCode: 'QUALITYARLARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 45,
            shuttleDateOffsetMinutesNoBag: 25,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    },
    {
      configType: 'DIRECT',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/quality-hotel-airport-arlanda.svg',
        logoAlt: 'quality-hotel-logo',
        header1SV: 'Boka transfer till Quality Hotel',
        header1EN: 'Book your transfer to Quality Hotel',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'QUALITYSHUARRDEP'
      },
      shuttlesConfig:
        [
          {
            type: ARRIVALTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'quality-hotel-xpo-arlanda-hotel-transfer',
            shuttleTypeCheckboxSV: 'Till Quality Hotel',
            shuttleTypeCheckboxEN: 'To Quality Hotel',
            shuttleTypeDescriptionSV: 'Transfer till Quality Hotel from Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Quality Hotel from Arlanda',
            productCode: 'QUALITYARLARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    }
  ]
};

export const BOOKING_CONFIG_AIDEN: BookingConfig = {
  organizationId: 'D6B9D8C6-8FB5-41A5-AC2E-B3FC007A8251',
  parkingId: '8C98315A-B2AD-4E70-86F9-5D54992FED26',
  timeZone: 'Europe/Stockholm',
  bookingConfigTypes: [
    {
      configType: 'HOTEL',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/Aiden-hotel-logo.svg',
        logoAlt: 'aiden-hotel-logo',
        header1SV: 'Boka transfer till och från Aiden Hotel',
        header1EN: 'Book transfer to and from Aiden Hotel',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: DEPARTURETIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'aiden-airport-transfer-new',
            shuttleTypeCheckboxSV: 'Till Arlanda',
            shuttleTypeCheckboxEN: 'To Arlanda',
            shuttleTypeDescriptionSV: 'Transfer till Arlanda från Aiden Hotel',
            shuttleTypeDescriptionEN: 'Transfer to Arlanda from Aiden Hotel',
            productCode: 'SHUTDEP',
            routeCode: 'QUALITYARLDEP',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
          {
            type: ARRIVALFLIGHTANDTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'aiden-hotel-transfer-new',
            shuttleTypeCheckboxSV: 'Till Aiden Hotel',
            shuttleTypeCheckboxEN: 'To Aiden Hotel',
            shuttleTypeDescriptionSV: 'Transfer till Aiden Hotel från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Aiden Hotel from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 45,
            shuttleDateOffsetMinutesNoBag: 25,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    },
    {
      configType: 'DIRECT',
      sendOrderConf: true,
      bookingNrDepartureRequired: false,
      bookingNrArrivalRequired: true,
      carIdRequired: false,
      headerConfig:
      {
        logoUrl: '../../../assets/img/Aiden-hotel-logo.svg',
        logoAlt: 'aiden-hotel-logo',
        header1SV: 'Boka transfer till Aiden Hotel',
        header1EN: 'Book your transfer to Aiden Hotel',
        header2SV: 'Bokning måste göras minst 20 minuter innan önskad transfer.',
        header2EN: 'Your booking needs to be done at least 20 minutes before your desired transfer time.',
      },
      orderConfig:
      {
        bundleCode: 'SDEPARR'
      },
      shuttlesConfig:
        [
          {
            type: ARRIVALTIMETABLE,
            stationCode: 'ARN',
            shuttleTypeCode: 'aiden-hotel-transfer-new',
            shuttleTypeCheckboxSV: 'Till Aiden Hotel',
            shuttleTypeCheckboxEN: 'To Aiden Hotel',
            shuttleTypeDescriptionSV: 'Transfer till Aiden Hotel från Arlanda',
            shuttleTypeDescriptionEN: 'Transfer to Aiden Hotel from Arlanda',
            productCode: 'SHUTARR',
            routeCode: 'QUALITYARLARR',
            shuttleDateOffsetMinutes: 0,
            shuttleDateOffsetMinutesNoBag: 0,
            terminals:
              [
                {
                  terminalName: 'Arlanda: Terminal 2 och 3',
                  terminalCode: 'T2-3'
                },
                {
                  terminalName: 'Arlanda: Terminal 4 och 5',
                  terminalCode: 'T4'
                }
              ]
          },
        ]
    }
  ]
};

export function getSwedenDateString(targetDate?: Date | string | number | any): string {
  let d: Date;
  if (!targetDate) {
    d = new Date();
  } else if (typeof targetDate === 'object' && targetDate && 'toDate' in targetDate && typeof targetDate.toDate === 'function') {
    d = targetDate.toDate();
  } else if (targetDate instanceof Date) {
    d = targetDate;
  } else {
    d = new Date(targetDate);
  }

  if (isNaN(d.getTime())) {
    if (typeof targetDate === 'string' && /^\d{4}-\d{2}-\d{2}/.test(targetDate)) {
      return targetDate.substring(0, 10);
    }
    d = new Date();
  }

  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Stockholm' }).format(d);
}

export function isT23MaintenancePeriod(targetDate?: Date | string | number | any): boolean {
  const swedenDateStr = getSwedenDateString(targetDate);
  if (!swedenDateStr) return false;

  const startDateStr = '2026-09-13';
  const endDateStr = '2026-11-30';

  return swedenDateStr >= startDateStr && swedenDateStr <= endDateStr;
}

export function filterTerminalsByDate<T extends { terminalCode?: string; terminalName?: string; name?: string; value?: string }>(
  terminals: T[],
  targetDate?: Date | string | number | any
): T[] {
  if (!terminals) return [];
  if (isT23MaintenancePeriod(targetDate)) {
    return terminals.filter(t => {
      const code = t.terminalCode || t.value || '';
      const name = t.terminalName || t.name || '';
      return code !== 'T2-3' && !name.includes('Terminal 2') && !name.includes('T2-3');
    });
  }
  return terminals;
}

export function formatTerminalLocationForDate(location?: string | null, targetDate?: Date | string | number | any): string {
  if (!location) return '';
  if (isT23MaintenancePeriod(targetDate)) {
    let loc = String(location);
    if (loc === 'Terminal 2' || loc === 'T2-3' || loc === 'T2') {
      return 'Terminal 4';
    }
    if (loc === 'Arlanda: Terminal 2 och 3') {
      return 'Arlanda: Terminal 4 och 5';
    }
    if (loc.includes('Terminal 2 och 3')) {
      return loc.replace('Terminal 2 och 3', 'Terminal 4 och 5');
    }
    if (loc.includes('Terminal 2')) {
      return loc.replace('Terminal 2', 'Terminal 4');
    }
    if (loc.includes('T2-3')) {
      return loc.replace('T2-3', 'Terminal 4');
    }
  }
  return location;
}